import { Chip } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

/** @typedef {'EM_ABERTO' | 'EM_ANALISE' | 'APROVADO' | 'REPROVADO'} ContractStatus */

/** @type {Record<ContractStatus, { bg: string; color: string }>} */
const STATUS_STYLE = {
  EM_ABERTO:  { bg: '#FFF8E1', color: '#F57F17' },
  EM_ANALISE: { bg: '#E3F2FD', color: '#1565C0' },
  APROVADO:   { bg: '#E8F5E9', color: '#2E7D32' },
  REPROVADO:  { bg: '#FCE4EC', color: '#C62828' },
};

/** @param {{ status: ContractStatus }} props */
const StatusChip = ({ status }) => {
  const { t } = useTranslation();
  const style = STATUS_STYLE[status] ?? { bg: '#F5F5F5', color: '#757575' };
  const label = STATUS_STYLE[status] ? t(`contracts.status.${status}`) : (status ?? '-');

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: 700,
        fontSize: '11px',
        borderRadius: '6px',
        height: '22px',
      }}
    />
  );
};

export default StatusChip;
